import z from "zod/v4";

import { BaseRequestArgs } from "../base-reader";
import { HistoryFilterParams, PaginatedResponseSchema } from "../pagination.types";

export interface UserFundingHistoryRequestArgs extends BaseRequestArgs, HistoryFilterParams {
  subAddr: string;
  limit?: number;
  offset?: number;
}

export const UserFundingSchema = z.object({
  market: z.string(),
  action: z.enum(["CloseLong", "CloseShort"]),
  size: z.number(),
  realized_funding_amount: z.number(),
  is_rebate: z.boolean(),
  fee_amount: z.number(),
  transaction_unix_ms: z.number(),
});

export const UserFundingHistorySchema = PaginatedResponseSchema(UserFundingSchema);

export type UserFunding = z.infer<typeof UserFundingSchema>;
export type UserFundingHistory = z.infer<typeof UserFundingHistorySchema>;
